export default __webpack_public_path__ + "static/media/background.7ac52196.webp";